import React from "react";
import styles from "./AboutDexa.module.scss";
import Image from "next/image";
import Link from "next/link";

const AboutDexa = () => {
  return (
    <section className={styles.AboutDexa}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Buy with
            <br /> <span className={styles.titleSpan}>Dexa</span>
          </h1>

          <p className={styles.paraghraph}>
            Swap or exchange your B-LOVE token from DEXA advanced decentralized
            exchange & trade platform for NFTs & Crypto Assets. The platform
            houses its own NFT marketplace & asset swap portal.
          </p>

          <div className={styles.flexContent}>
            <div>
              <Image
                alt='dexa'
                src='/assets/svg/dexa.png'
                width={25}
                height={25}
              />
            </div>
            <p className={styles.text}>Register on dexa.exchange</p>
          </div>
          <div className={styles.flexContent}>
            <div>
              {' '}
              <Image
                alt='dexa'
                src='/assets/svg/dexa.png'
                width={25}
                height={25}
              />
            </div>
            <p className={styles.text}>
              Link your Love Wallet or MetaMask wallet
            </p>
          </div>

          <div className={styles.flexContent}>
            <div>
              <Image
                alt='dexa'
                src='/assets/svg/dexa.png'
                width={25}
                height={25}
                priority
              />
            </div>
            <p className={styles.text}>Go to dexa.exchange/swap</p>
          </div>

          <div className={styles.flexContent}>
            <div>
              <Image
                alt='dexa'
                src='/assets/svg/dexa.png'
                width={25}
                height={25}
                priority
              />
            </div>
            <p className={styles.text}>Swap your USDB or BFIC for BLV tokens</p>
          </div>

          <div className={styles.qrcode}>
            <Link href={'https://dexa.exchange/'} target='_blank'>
              <button className={styles.btn}>Visit Dexa</button>
            </Link>
            <Image
              alt='qr'
              src='/assets/Image/qr.png'
              width={90}
              height={90}
              priority
            />
          </div>
        </div>

        <div className={styles.image}>
          <Image
            src='/assets/Image/Group 1171275373.png'
            width={500}
            height={588}
            alt='image'
            priority
            className={styles.img}
          />
        </div>
      </div>
    </section>
  )
};

export default AboutDexa;
